import { Directive, Self } from '@angular/core';
import { PieChartComponent } from '@swimlane/ngx-charts';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'ngx-charts-pie-chart[hotfix-zero-margin]',
    standalone: false
})
export class NgxPieChartZeroMarginDirective {
	constructor(@Self() pieChart: PieChartComponent) {
		pieChart.margins = [0, 0, 0, 0];
	}
}
